import { paths, pathsApi } from '../../router/paths';
import { parse as parseCookie } from 'cookie';
import state from '../../state';
import { setNotificationError } from '../../state/reducers/notification';

const API_PREFIX = '/myapi';
const API_HOST = globalThis.location.origin;
const X_CSRF_TOKEN = 'x-csrf-token';
const X_CSRF_COOKIE = 'csrftoken';

const sendError = (e: string) => {
    state.dispatch(setNotificationError(e));
};

const handleLogin = (response: Response) => {
    if (response.redirected && response.url === new URL(paths.login, globalThis.location.origin).href) {
        globalThis.window.open(paths.login, '_blank');

        return true;
    }
};

const handleError = async (response: Response) => {
    if (response.status === 400) {
        const responseMessage = await response.json();
        const message = responseMessage.message;
        sendError(message || response.statusText);

        return true;
    }
};

export const FetchApi = {
    get: async <T>(path: string): Promise<T | undefined> => {
        try {
            const response = await fetch(API_HOST + API_PREFIX + path, {
                method: 'GET',
                headers: {
                    'Accept-Content': 'application/json',
                } as HeadersInit,
            });
            if (handleLogin(response) || (await handleError(response))) {
                return;
            }
            if (response.ok) {
                return await response.json();
            }
            sendError(response.statusText);
        } catch (e) {
            sendError((e as Error).message);
        }
    },
    post: async <T>(path: string, body: any): Promise<T | undefined> => {
        try {
            const cookies = parseCookie(document.cookie);
            const response = await fetch(API_HOST + API_PREFIX + path, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Content': 'application/json',
                    [X_CSRF_TOKEN]: cookies[X_CSRF_COOKIE],
                } as HeadersInit,
                body: JSON.stringify(body),
            });
            if (handleLogin(response) || (await handleError(response))) {
                return;
            }
            if (response.ok) {
                return await response.json();
            }
            sendError(response.statusText);
        } catch (e) {
            sendError((e as Error).message);
        }
    },
    uploadFile: async <T>(body: any): Promise<T | undefined> => {
        try {
            const cookies = parseCookie(document.cookie);
            const response = await fetch(API_HOST + API_PREFIX + pathsApi.uploadFile, {
                body: body,
                headers: {
                    'Accept-Content': 'application/json',
                    [X_CSRF_TOKEN]: cookies[X_CSRF_COOKIE],
                } as HeadersInit,
                method: 'POST',
            });
            if (handleLogin(response) || (await handleError(response))) {
                return;
            }
            if (response.ok) {
                return await response.json();
            }
            sendError(response.statusText);
        } catch (e) {
            sendError((e as Error).message);
        }
    },
    postLogin: async (path: string, body: any): Promise<Response | undefined> => {
        const cookies = parseCookie(document.cookie);
        const response = await fetch(API_HOST + API_PREFIX + path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Content': 'application/json',
                [X_CSRF_TOKEN]: cookies[X_CSRF_COOKIE],
            } as HeadersInit,
            body: JSON.stringify(body),
        });
        if (response.ok) {
            return response;
        }
    },
};
